import { render, staticRenderFns } from "./ShowMsgContent.vue?vue&type=template&id=5e6313a1&"
import script from "./ShowMsgContent.vue?vue&type=script&lang=js&"
export * from "./ShowMsgContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports